import { ActionNames } from '../action-names';
import { IAppState } from '../models';

export type UpdateRouterCurrentUrl = { type: ActionNames.UPDATE_ROUTER_CURRENT_URL; value: string };
export type UpdateCurrentRouteName = { type: ActionNames.UPDATE_CURRENT_ROUTE_NAME; value: string };

export function routerActionHandlers(currentState: IAppState, action: UpdateRouterCurrentUrl | UpdateCurrentRouteName): IAppState {

    switch (action.type) {
        case ActionNames.UPDATE_ROUTER_CURRENT_URL: {
            return {
                ...currentState,
                router:
                {
                    ...currentState.router,
                    currentUrl: action.value
                }
            };
        }
        case ActionNames.UPDATE_CURRENT_ROUTE_NAME: {
            return {
                ...currentState,
                router:
                {
                    ...currentState.router,
                    routeName: action.value
                }
            };
        }
        default:
            return currentState;
    }
}
